export const BAR_AXIS_SPACE = 30
export const BAR_TEXT_LENGTH = 18

export const svgTextStyle: any = {
  fontFamily: 'roboto',
  fontSize: '0.75rem',
  textAlign: 'end',
}
//add a functionality for dynamic values to convert from px to rem
export const containerStyles: any = (
  containerHeight: number = 300,
  data?: any,
) => ({
  width: '100%',
  height: `${containerHeight + 10}px`,
  ...(data.length > 15 ? { overflowY: 'scroll' } : { overflowY: 'hidden' }),
  overflowX: 'hidden',
})

export const tickFormatter = (value: string) =>
  value.length < BAR_TEXT_LENGTH
    ? value
    : `${value.substring(0, BAR_TEXT_LENGTH)}...`

export const yAxisProps: any = (xKey: string = 'count') => ({
  yAxisId: 0,
  dataKey: xKey,
  type: 'category',
  tickLine: false,
  axisLine: false,
  tickFormatter,
  interval: 0,
  tick: false,
})

export const barSize = (data: any, containerHeight?: number) => {
  const barDataLength = data.length
  let height,
    chartHeight = containerHeight
  switch (true) {
    case barDataLength <= 6:
      height = 20
      break

    case barDataLength > 15:
      height = 15
      chartHeight = 30 * data.length
      break

    case barDataLength <= 14 && barDataLength > 7:
    default:
      height = 15

      break
  }
  return { height, chartHeight }
}
